/**
 * @generated SignedSource<<8b76544984fcd858e7010597e0e15dbd>>
 * @relayHash 20be82ec3bbc9afb5445ff94a6193a38
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 20be82ec3bbc9afb5445ff94a6193a38

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "PropositionsCommercialesMutationResponse",
    "kind": "LinkedField",
    "name": "propositionsCommerciales",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archiveName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropositionsCommercialesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropositionsCommercialesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "20be82ec3bbc9afb5445ff94a6193a38",
    "metadata": {},
    "name": "PropositionsCommercialesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "c230c2ca55eecb8bb5417a4dbb35b5f9";

export default node;
